<template>
  <div class="bind-pdd-pop" @click.stop>
    <div class="g-close" @click="hideSaasPop">
      <img src="../../assets/icon-close@2x.png" width="12" alt>
    </div>

    <section v-show="step === 1" class="pop-content">
      <div class="g-close" @click="hideSaasPop">
        <img src="../../assets/icon-close@2x.png" width="12" alt>
      </div>
      <header class="header">
        <div>
          <h3 class="title">
            暂未绑定拼多多账号
          </h3>
          <p>完成以下步骤，绑定拼多多账户，完成商品上架</p>
        </div>
      </header>
      <section class="inner-content">
        <div class="guide-item">
          <p class="tip">
            1. 跳转到多多进宝授权页面
          </p>
          <img class="image" src="../../assets/bind-pdd-1.png" alt>
        </div>
        <div class="guide-item">
          <p class="tip">
            2. 手机号验证码注册、登陆多多进宝
          </p>
          <img class="image" src="../../assets/bind-pdd-2.png" alt>
        </div>
        <div class="guide-item">
          <p class="tip">
            3. 登陆成功，确认授权
          </p>
          <img class="image" src="../../assets/bind-pdd-3.png" alt>
        </div>
      </section>
      <footer class="footer">
        <qc-button size="small" @click.stop="goToPddBindPage">
          去绑定拼多多账号
        </qc-button>
        <qc-button
          class="bindSaasPopBtn"
          data-compname="bindSaasPopBtn"
          data-saas_type="pdd"
          type="weak"
          size="small"
          @click="onConfirmBind"
        >
          确定绑定
        </qc-button>
      </footer>
    </section>

    <section v-show="step === 2" class="pop-content1">
      <div>
        <div class="g-close" @click="hideSaasPop">
          <img src="../../assets/icon-close@2x.png" width="12" alt>
        </div>
        <img src="../../assets/icon-success@2x.png" width="85" alt>
        <p class="tip">
          授权成功
        </p>
        <p class="tip">
          您的拼多多PID是：xxxxxxx_xxxxxxxx
        </p>
        <div class="panel-wrap">
          <qc-button @click="hideSaasPop">
            去挑选
          </qc-button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import commonMixin from '@/mixins/common';

export default {
  name: 'BindPDDPop',
  mixins: [commonMixin],
  data() {
    return {
      step: 1,
    };
  },
  computed: {
    ...mapState({
      profile: state => state.userCenter.profile,
      bindSaasPop: state => state.common.bindSaasPop,
    }),
    ...mapGetters({
      isBindPdd: 'userCenter/isBindPdd',
      saasInfo: 'userCenter/saasInfo',
    }),
    pddBindUrl() {
      return this.getBindUrl('pdd');
    },
  },
  methods: {
    getBindUrl(saasType) {
      const bindInfo = this.profile.saas_binding.filter(item => item && item.mask === saasType)[0];
      return bindInfo ? bindInfo.authenticate_entry : '';
    },
    goToPddBindPage() {
      if (!this.pddBindUrl) {
        this.$tip.error('拼多多绑定URL不存在');
        return;
      }

      sessionStorage.setItem('isPddRebind', this.bindSaasPop.isPddRebind);
      window.open(this.pddBindUrl);
    },
    onClose() {
      this.$store.commit('common/HIDE_BIND_SAAS_POP');
    },

    hideSaasPop() {
      this.$store.commit('common/HIDE_BIND_SAAS_POP');
    },
    async onConfirmBind() {
      await this.$store.dispatch('userCenter/fetchCpProfile');
      if (!this.isBindPdd) {
        this.$tip.error('绑定失败，请确认拼多多已绑定');

        return;
      }

      this.$store.commit('common/HIDE_BIND_SAAS_POP');
    },
  },
};
</script>

<style lang="less" scoped>
@popH: 500px;
@popHeaderH: 100px;
@popFooterH: 80px;

.bind-pdd-pop {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 3;
  background-color: rgba(0, 0, 0, 0.3);
  .g-close {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 20px;
    height: 20px;
    img {
      cursor: pointer;
    }
  }
  .pop-content {
    position: relative;
    width: 1000px;
    height: @popH;
    background-color: #fff;
    border-radius: 4px;
    .header {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      height: @popHeaderH;
      .title {
        margin-bottom: 10px;
      }
    }
    .inner-content {
      height: calc(@popH - @popHeaderH - @popFooterH);
      display: flex;
      justify-content: center;
      background-color: rgb(239, 239, 239);
      .guide-item {
        padding: 20px 10px;
        text-align: center;
        flex: 1;
        .tip {
          margin-bottom: 10px;
        }
        .image {
          height: 240px;
        }
      }
      .guide-item1 {
        display: flex;
        justify-content: center;
        align-items: center;
        .tip {
          margin-top: 20px;
          .em {
            color: var(--ui-main-color);
          }
        }
      }
    }

    .footer {
      display: flex;
      justify-content: center;
      align-items: center;
      height: @popFooterH;
    }
  }
  .pop-content1 {
    position: relative;
    width: 500px;
    height: 500px;
    background-color: #fff;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    .tip {
      margin-top: 20px;
    }
    .panel-wrap {
      position: relative;
      top: 100px;
    }
  }
}
</style>
